import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import PropTypes from "prop-types";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import ReportHeader from "../report-header";
import ScheduleReportList from "../schedule/schedule-report-list";
import {
    requestExportChargeApprovalReportExcel,
} from "../../../../actions/draftActions";

class ChargeApprovalReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {
                fromDate: moment()
                    .startOf("month"),
                toDate: moment()
                    .endOf("month"),
            },
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect = (name, option) => {
        const filters = Object.assign({}, this.state.filters);
        filters[name] = option;
        this.setState({
            filters
        });
    };

    render() {
        const {
            filters
        } = this.state;

        return (
            <div className="position-relative container">
                <ReportHeader
                    isChargeApproval={true}
                    filters={filters}
                    handleSelect={this.handleSelect}
                />
                <ScheduleReportList
                    isChargeApproval={true}
                    filters={filters}
                    handleClose={this.props.handleClose}
                    handleSubmit={this.props.requestExportChargeApprovalReportExcel}
                />
            </div>
        );
    }
}

ChargeApprovalReportModal.propTypes = {
    handleClose: PropTypes.func.isRequired
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    requestExportChargeApprovalReportExcel:
        bindActionCreators(requestExportChargeApprovalReportExcel, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(ChargeApprovalReportModal);
